export default __webpack_public_path__ + "static/media/7.596aa619.webp";